module.exports = __webpack_public_path__ + "img/login.bd1906d7.png";